import { z } from "zod";

export type PaymentFormType = z.infer<typeof paymentFormSchema>;

export const paymentFormSchema = z.object({
    storeCard: z.boolean(),
});

export const formBoxSx = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "8px",
};
